import { reactive } from "vue";
import type { Legend } from "@/types/legend.types";

export type ReadMode = "readonly" | "edit";

export default reactive({
  isOpen: false,
  legend: null as Legend | null,
  mode: "readonly" as ReadMode,
  show(legend: Legend, mode: ReadMode) {
    this.legend = legend;
    this.mode = mode;
    this.isOpen = true;
  },
  hide() {
    this.isOpen = false;
  },
});
